import axios from 'axios'

export const getTeam = async ({ id }) => {
  const url = process.env.REACT_APP_ADMIN_API + `/teams/${id}`
  const response = await axios.get(url, {})
  return response.data.vercelResponse
}
